import App from './App.vue';
import { createApp, h } from 'vue';
import { VueServerRequest } from '@nutshell/vue';
import { AppConfig } from '@config';

/**
 * Loading Vue plugins for usage.
 */
import router from './router';
import store from './store';
import directives from './directives';

import Page from '@support/Page';
import print from 'print-js'
import { ValidationError } from './errors';
import Filters from '@support/Filters';
import Constants from '@support/Constants';

/**
 * Control your routing with the beforeEach event.
 * For example. Check here if a user is logged in and redirect the user to the correct page.
 */
router.beforeEach(Page.controlRouting);

/**
 * Adding xhr to the vuex store. Your ServerRequest is available in the variabele this.$xhr in your store.
 */
//store.$xhr = xhr.getInstance();

/**
 * Creating vue instance.
 * Available plugins in your vue component:
 * - $router
 * - $route
 * - $store
 * - $socket
 * - $xhr
 *
 */
const vueApp = createApp({
	render: () => h(App)
});

vueApp.use(directives);
vueApp.use(store);
vueApp.use(router);
// vueApp.use(VueSocket); //If not used, remove it
vueApp.use(VueServerRequest);
vueApp.use(Filters);
vueApp.use(Constants);

//Bij 419 response nieuw xsrf token inladen en opnieuw proberen
const parentSend = vueApp.config.globalProperties.$xhr.send;
const newSend = function () {
	const self = this;
	const args = arguments;
	return new Promise((resolve, reject) => {
		const first = parentSend.apply(this, arguments);
		first
			.then(resolve)
			.catch(function (result) {
				switch (result.status) {
					case 419:
						//kan niet via /sanctum/csrf-cookie want cookies worden op de coolwork en productieservers tot HttpOnly "beveiligd"
						vueApp.config.globalProperties.$xhr.get('/api/auth/token')
							.then(response => {
								vueApp.config.globalProperties.$xhr.options.headers['X-XSRF-TOKEN'] = response.result;
								resolve(newSend.apply(self, args));
							});
						break;
					case 422:
						//laravel geeft fouten terug met als key een puntgescheiden pad naar de value
                        let nestedErrors = {};
                        Object.entries(result.result.errors).forEach(([fieldName, errorList]) => {
                            const fieldNameParts = fieldName.split('.');
                            const lastPart = fieldNameParts.pop();
                            fieldNameParts.reduce((nestedError, part) => nestedError[part] ??= {}, nestedErrors)[lastPart] = errorList;
                        });
						reject(new ValidationError(nestedErrors));
						break;
					case 401:
						router.push({name: 'login'});
					default:
						reject(result);
				}
			})
	})
}

vueApp.config.globalProperties.$xhr.send = newSend;
vueApp.config.unwrapInjectedRef = true;
vueApp.mount(AppConfig.mount || '#application');
